export enum TargetAudience {
  storeLevel = 'STORE_LEVEL',
  userLevel = 'USER_LEVEL',
}
